/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Csv_Export_Invalid_RowsInputs */

const en_statement_tree_csv_export_invalid_rows = /** @type {(inputs: Statement_Tree_Csv_Export_Invalid_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was exported. Complete Level1 and Level2 in every row of both statements and use unique RowId values so the CSV can be imported again.`)
};

const nl_statement_tree_csv_export_invalid_rows = /** @type {(inputs: Statement_Tree_Csv_Export_Invalid_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is niets geëxporteerd. Vul Level1 en Level2 in bij elke regel van beide staten en gebruik unieke RowId-waarden, zodat de CSV opnieuw kan worden geïmporteerd.`)
};

/**
* | output |
* | --- |
* | "Nothing was exported. Complete Level1 and Level2 in every row of both statements and use unique RowId values so the CSV can be imported again." |
*
* @param {Statement_Tree_Csv_Export_Invalid_RowsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_export_invalid_rows = /** @type {((inputs?: Statement_Tree_Csv_Export_Invalid_RowsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Export_Invalid_RowsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_export_invalid_rows(inputs)
	return en_statement_tree_csv_export_invalid_rows(inputs)
});